module.exports = __webpack_public_path__ + "img/drug.bfa36025.png";